import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import {
    uniqBy,
    runOwsRequestWithMonitor,
    HubPersona,
    createHubPersona,
    Feature,
    fullResponseOperationOption,
} from '../../shared';
import { FindPeopleJsonResponse, getServiceAsync } from '../../service';
import type { QueryData } from '../models/query';
import { getFindPeopleRequest } from './common/baseFindPeopleRequest';

const retrieveSuggestionCount: number = 10;

// Returns up to 10 search suggestions.
export function searchSuggestedPersonas(queryData: QueryData): Promise<HubPersona[]> {
    return getServiceAsync().then(service =>
        runOwsRequestWithMonitor({
            scenarioName: 'SearchSuggestedPersonas',
            feature: Feature.Search,
            operation: () =>
                service.Operation.findPeopleOperation(
                    service.Factory.findPeopleJsonRequest({
                        Header: getJsonRequestHeader(),
                        Body: service.Factory.findPeopleRequest(
                            getFindPeopleRequest(
                                service.Factory,
                                queryData,
                                queryData.isAllFolder,
                                retrieveSuggestionCount
                            )
                        ),
                    }),
                    fullResponseOperationOption
                ),
            transformResponse: (owsResponse: FindPeopleJsonResponse) => {
                const results = uniqBy(
                    owsResponse.Body.ResultSet,
                    persona => persona.PersonaId.Id
                ).map(createHubPersona);
                // Subtract ε < 1 (index / count) to tie-break equal relevancy with the order returned
                return results.map((result, index) => ({
                    ...result,
                    relevancyScore: (result.relevancyScore || 0) - index / results.length,
                }));
            },
        })
    );
}
